import { tns } from "../../../node_modules/tiny-slider/src/tiny-slider"

export default class Slider {

  constructor(selector) {
    this.sliders = document.querySelectorAll(selector);
    if (!this.sliders) {
      return;
    }

    for (let i = 0; i < this.sliders.length; ++i) {
      const slider = this.sliders[i];
      if (slider.dataset.sliderInitialized) {
        continue;
      }
      slider.dataset.sliderInitialized = true
      const sliderItems = slider.querySelectorAll('.slider--item');

      if (sliderItems.length > 0) {
        const sliderInstance = tns({
          container: slider,
          mode: 'gallery',
          speed: 2000,
          autoplay: true,
          autoplayTimeout: 4000,
          autoplayButtonOutput: false,
          controls: !!!slider.classList.contains('slider-no-controls'),
          touch: false,
          nav: false,
        });

      }
    }
  }

}
